import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import {
  GlobalService,
  LogService,
} from '@medlogic/shared/shared-interfaces';
import { IAppMedlogicFhirState } from '../../iapp-medlogic-fhir';


@Injectable()
export class ScheduledTimingEffects {

  constructor(
    private glb: GlobalService,
    private log: LogService,
    private actions$: Actions,
    private store: Store<IAppMedlogicFhirState>,
  ) { }

  // FIXME: Falta implementar regra de negócio para alertas de sinais vitais e de evolução
  // loadScheduledTimings$ = createEffect(() => this.actions$
  //   .pipe(
  //     ofType(loadScheduledTimings),
  //     withLatestFrom(this.store),
  //     mergeMap(([never, state]) => {
  //       // return this.scheduledTimingSrv.getAll(state?.tenant?.selectedTenant?.cadPacienteNo)
  //       const { cadPacienteNo, cadAutorizacaoCuidadoNo } = state?.tenant?.selectedTenant;
  //       return this.scheduledTimingSrv.getAuthorizedScheduledTimings(cadPacienteNo, cadAutorizacaoCuidadoNo)
  //         .pipe(
  //           // toArray(),
  //           first(),
  //           mergeMap(scheduledTimings => {
  //             // FIXME: ATENÇÃO: Esse cálculo está errado, pois, precisa considerar as medicações que se repetem em horários diferentes
  //             return this.intervMedSrv.getMedicationCountForScheduledTimings(state?.tenant?.selectedTenant?.cadIntervecoesMedicamentosNo, scheduledTimings)
  //               .pipe(
  //                 map(count => {
  //                   return scheduledTimings.map(m => ({ ...m, calcMedicationsCount: count[+m.codigo] } as IScheduledTiming));
  //                 }));
  //           }),
  //           switchMap((scheduledTimings: IScheduledTiming[]) => [
  //             scheduledTimings ? loadScheduledTimingsSuccess({ scheduledTimings }) : scheduledTimingFail(null),
  //             setIsLoading({ isLoading: false })
  //           ]),
  //           catchError((e: any) => {
  //             console.log(e);
  //             return of(scheduledTimingFail(null));
  //           })
  //         );
  //     })
  //   )
  // );

  // loadScheduledTimingWithMedications$ = createEffect(() => this.actions$
  //   .pipe(
  //     ofType(loadScheduledTimingsWithMedications),
  //     withLatestFrom(this.store),
  //     mergeMap(([never, state]) => {
  //       this.store.dispatch(setIsLoading({ isLoading: true }));
  //       this.store.dispatch(setIsLoadingMedication({ isLoading: true }));
  //       const { tenantId, selectedTenant } = state?.tenant;
  //       const { cadPacienteNo, cadEvolutionNo,
  //         cadIntervecoesMedicamentosNo, cadCheckMedicamentosNo,
  //         cadIntervecoesHorariosNo, cadVitalSignsNo, cadAutorizacaoCuidadoNo } = selectedTenant;
  //       const dtEnd = this.glb.addDays(new Date(), 1); // Necessário para incluir a data do dia
  //       const dtStart = new Date();
  //       return this.scheduledTimingSrv.getScheduledTimingsWithMedications(
  //         cadPacienteNo,
  //         cadEvolutionNo,
  //         cadIntervecoesMedicamentosNo,
  //         cadCheckMedicamentosNo,
  //         cadIntervecoesHorariosNo,
  //         cadVitalSignsNo,
  //         cadAutorizacaoCuidadoNo,
  //         tenantId,
  //         dtStart,
  //         dtEnd,
  //         1
  //       )
  //     }),
  //     switchMap((scheduledTimings: IScheduledTiming[]) => [
  //       scheduledTimings ? loadScheduledTimingsSuccess({ scheduledTimings }) : scheduledTimingFail(null),
  //       addMedications({ medications: this.getMedications(scheduledTimings) }),
  //       setIsLoading({ isLoading: false }),
  //       setIsLoadingMedication({ isLoading: false })
  //     ]),
  //     catchError((e: any) => {
  //       console.log(e);
  //       return of(scheduledTimingFail(null));
  //     })
  //   ));

  // /* Além de extrair a lista de medicamentos de todos os pacientes, irá padronizar o prescribeTime,
  // * pois o mesmo é utilizado para cálculos e também para a formação do id. Há registros que vem como 8 ao invés de 08:00
  // */
  // protected getMedications(scheduledTimings: IScheduledTiming[]): IMedication[] {
  //   try {
  //     const mapMeds = (medications: IMedication[]) => {
  //       return medications?.filter(f => f)?.map(m => ({ ...m, prescribedTime: this.glb.formatTime(m.prescribedTime), status: (m.status || '') } as IMedication))
  //     };
  //     return scheduledTimings?.reduce((a, b) => [...a, ...mapMeds(b.medications)], []);
  //   } catch (error) {
  //     this.log.Registrar(this.constructor.name, 'getMedications', error.message);
  //   }
  //   return null;
  // }

  // protected firstUpperCase(str: string): string {
  //   try {
  //     const siglas = ['SIGLA'];
  //     if (siglas.includes(str.toUpperCase())) {
  //       return str.toUpperCase();
  //     }
  //     return this.glb.primeiraMaiuscula(str);
  //   } catch (error) {
  //     this.log.Registrar(this.constructor.name, 'firstUpperCase', error.message);
  //   }
  //   return str;
  // }


}
